import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast-wrapper" }

import { computed } from 'vue'
interface TOAST_PROPS {
  message: string
  type: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ToastGeneral',
  props: {
    message: {},
    type: {}
  },
  setup(__props: any) {

const props = __props
const background = computed<string>(() => {
  if (props.type === 'success') {
    return '#00c853'
  } else if (props.type === 'error') {
    return '#ff5252'
  } else if (props.type === 'warning') {
    return '#ff9800'
  } else if (props.type === 'info') {
    return '#2196f3'
  }
  return '#ff9800'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle({ background: background.value }),
      class: "toast"
    }, _toDisplayString(props.message), 5)
  ]))
}
}

})